export default {
  appTitle: 'Authorizations',
  filters: {
    searchCode: 'Search by ID',
    coverage: 'Coverage',
    status: 'Status',
    date: 'Date range'
  },
  dataTableHeaders: {
    id: 'ID',
    createdAt: 'Creation date',
    sponsorName: 'Insurer',
    beneficiaryName: 'Insured person’s name',
    beneficiaryMemberCode: 'Member card',
    coverageType: 'Authorization type',
    status: 'Status'
  },
  resultLabel: {
    text: `Results`,
    result: `({result})`
  },
  status: {
    ready: 'Pending validation',
    rejected: 'Rejected',
    qualification: 'Hospital admission',
    pendingReview: 'In assessment',
    approved: 'Assessed',
    claimed: 'Invoiced',
    completed: 'Completed',
    voided: 'Voided',
    notAttended: 'Not Attended',
    sentToSponsor: 'Sent to the sponsor',
    paymentConfirmed: 'Payment confirmed',
    paid: 'Paid'
  },
  coverage: {
    hospitalization: 'Hospitalization'
  },
  addAuthorization: {
    title: 'New assessment',
    creating: 'Creating authorization...'
  },
  diagnoses: {
    panelTitle: 'Diagnoses',
    title: 'Diagnoses',
    emptyState: 'No diagnoses have been added yet',
    customDiagnosisItemListLabel: 'Diagnosis',
    searchLabel: 'Search diagnosis',
    searchCustom: 'Search {label}',
    emptyStateCustom: 'No {label} have been added',
    emptyList: 'No results found',
    addDiagnosisLabel: "+ Add '{value}'",
    maximumNumberOfItemsReached: 'Maximum amount reached',
    errors: {
      repeated: 'This diagnosis has already been added'
    }
  },
  beneficiaryHeader: {
    name: 'Full name',
    identityDocumentId: 'Identification',
    beneficiaryEmail: 'Email',
    memberCode: 'Member number'
  },
  medicalProcedure: {
    searchLabel: 'Search medical procedure',
    emptyState: 'No medical procedures have been added yet'
  },
  buttons: {
    next: 'Continue',
    end: 'Finish',
    cancel: 'Cancel',
    return: 'Return',
    add: 'Add',
    exit: 'Exit',
    btnLink: 'View documentation'
  },
  statusProductsAuthorizations: {
    approved: 'Approved',
    rejected: 'Rejected',
    manualReviewRequired: 'Requires manual review'
  },
  authorizationProductsDetails: {
    headers: {
      codeDiagnoses: 'ICD-10 Code',
      codeProduct: 'CPT',
      name: 'Name',
      status: 'Status'
    },
    emptyList: 'No results found'
  },
  uploadPreInvoiceSuccess: 'The patient was discharged successfully.',
  uploadInvoiceSuccess: 'The invoice has been sent successfully.',
  authorizationPreInvoiceItems: {
    headers: {
      name: 'Product',
      discount: 'Discount',
      quantity: 'Quantity',
      unitPrice: 'Unit price',
      total: 'Total',
      status: 'Status',
      accountStatement: 'Account statement',
      approved: 'Approved products',
      rejected: 'Rejected products',
      sum: 'Sum',
      totalDiscount: 'Discounts',
      taxes: 'Taxes',
      subtotal: 'Total',
      totalAdvanced: 'Advance',
      totalToPay: 'To pay',
      searchFilter: 'Search by product and status'
    }
  }
}
